import { render, staticRenderFns } from "./SupplierGoodsReturns.vue?vue&type=template&id=358d4436&scoped=true"
import script from "./SupplierGoodsReturns.vue?vue&type=script&lang=js"
export * from "./SupplierGoodsReturns.vue?vue&type=script&lang=js"
import style0 from "./SupplierGoodsReturns.vue?vue&type=style&index=0&id=358d4436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358d4436",
  null
  
)

export default component.exports